import { FC } from 'react';
import { Page } from 'components/molecules/page';

type SettingsPageHeader = {
  titleComponent: FC;
};

const SettingsPageHeader = (props) => {
  const { titleComponent } = props;

  return <Page.Header $white sticky title={titleComponent} />;
};

export { SettingsPageHeader };
